import React from "react";
import { useSelector } from "react-redux";

// Higher Order Component
const withUserProp = (WrappedComponent) => {
  // Return a new functional component connected to the Redux store
  const WithUserPropComponent = (props) => {
    const user = useSelector((state) => state.auth.user);

    // Spread the user prop and other props to the WrappedComponent
    return <WrappedComponent {...props} user={user} />;
  };

  return WithUserPropComponent;
};

export default withUserProp;
